import React from "react";
import TankRobsTable, { TankRobRow } from "./TankRobsTable";

export interface BunkerTankRobsData {
	vessel_name?: string;
	vessel_imo?: string;
	brt_lfo_specific_gravity?: string;
	brt_mgo_specific_gravity?: string;
	brt_lfo_table?: TankRobRow[];
	brt_remarks?: string;
	brt_mgo_table?: TankRobRow[];
	brt_report_date?: string;
	brt_report_time?: string;
	brt_report_zd?: string;
}

interface BunkerTankRobsTablesProps {
	bunkerTankRobs?: BunkerTankRobsData;
}

function BunkerTankRobsTables({ bunkerTankRobs }: BunkerTankRobsTablesProps) {
	if (!bunkerTankRobs) return null;

	return (
		<>
			<TankRobsTable
				title="LFO Tanks ROB"
				rows={bunkerTankRobs.brt_lfo_table}
				sgValue={bunkerTankRobs?.brt_lfo_specific_gravity}
			/>
			<TankRobsTable
				title="MGO Tanks ROB"
				rows={bunkerTankRobs.brt_mgo_table}
				sgValue={bunkerTankRobs?.brt_mgo_specific_gravity}
			/>
		</>
	);
}

export default BunkerTankRobsTables;
